import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedDate, injectIntl } from 'react-intl'
import styled from 'styled-components'
import { getMileageUnit } from 'core/utils/cultures/unit'
import svg from 'assets/svg'
import { stockShape } from '../../shapes'
import RenderRow from './RenderRow'

const ListInfosWrapper = styled.div`
  margin: 10px 0;
  width: 100%;
  color: ${props => props.theme.colors.color2.bg};
  }
`

const renderRow = (label, value, icon) => <RenderRow label={label} value={value} icon={icon} />

const ListInfos = props => {
  const { stock, intl } = props

  const { selectedVehicle } = stock

  const {
    energy,
    dateOfRegistration,
    mileage,
    CV,
    CH,
    seating,
    doors,
    gearBoxType,
    transmission,
    NumberOfReports,
    CO2,
    colors,
    warranty,
    registrationPlate,
    reference
  } = selectedVehicle

  return (
    <ListInfosWrapper data-test="component-stock-vehicles-list-vehicleItem-ListInfos">
      {energy &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-energy" />,
          energy,
          svg.gas_pump
        )}

      {dateOfRegistration &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-dateOfRegistration" />,
          <FormattedDate value={dateOfRegistration} month="numeric" year="numeric" />,
          svg.calendar
        )}

      {mileage &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-mileage" />,
          `${intl.formatNumber(mileage)} ${getMileageUnit()}`,
          svg.road
        )}

      {CV &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-CV" />,
          `${intl.formatNumber(CV)} CV`,
          svg.power
        )}

      {CH &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-CH" />,
          `${intl.formatNumber(CH)} Ch/DIN`,
          svg.power
        )}

      {seating &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-seating" />,
          <FormattedMessage
            id="stock-vehicle-detail-list-infos-seating-value"
            values={{ seats: seating }}
          />,
          svg.seat
        )}

      {doors &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-doors" />,
          <FormattedMessage id="stock-vehicle-detail-list-infos-doors-value" values={{ doors }} />,
          svg.doors
        )}

      {gearBoxType &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-gearbox" />,
          gearBoxType,
          svg.reports
        )}

      {transmission &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-transmission" />,
          transmission,
          svg.transmission
        )}

      {NumberOfReports &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-NumberOfReports" />,
          NumberOfReports,
          svg.reports
        )}

      {CO2 &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-CO2" />,
          `${intl.formatNumber(CO2)} g/km`,
          svg.cloud_2
        )}

      {colors &&
        colors.external &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-color" />,
          colors.external,
          svg.brush
        )}

      {warranty &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-warranty" />,
          warranty,
          svg.shield
        )}

      {registrationPlate &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-registration" />,
          registrationPlate,
          svg.registration
        )}

      {reference &&
        renderRow(
          <FormattedMessage id="stock-vehicle-detail-list-infos-reference" />,
          reference,
          svg.flag
        )}
    </ListInfosWrapper>
  )
}

ListInfos.propTypes = {
  intl: PropTypes.shape().isRequired,
  stock: stockShape.isRequired
}

export default injectIntl(ListInfos)
